import React, { memo } from 'react';
import ListViewMailItem from './ListViewMailItem';
import GridViewMailItem from './GridViewMailItem';
import { MailItemComponentType } from '../../Types/MailItemTypes';

const MailboxMailItemMapper = memo((props: MailItemComponentType) => {
	if (props.mailView === 'grid') {
		return <GridViewMailItem {...props} />;
	}

	return <ListViewMailItem {...props} />;
});

export default MailboxMailItemMapper;
